module.exports = __webpack_public_path__ + "img/iso45001-cn.a10d7bba.png";